export default "__VITE_ASSET__CE3LtydP__"